<button type="button" class="clear-filters-button" (click)="onClear()">
  {{ label }}
</button>
